const groupDataBy = (xs: Array<Object>, key: string) => xs.reduce((rv, x) => {
    // @ts-ignore
    const newKey = x[key] || 'brak klasyfikacji';
    // @ts-ignore
    (rv[newKey] = rv[newKey] || []).push(x);
    return rv;
}, {});

const includesCaseInsesitive = (array: Array<string>, value: string) => array.filter((str: string) => str.toLowerCase().includes(value.toLowerCase())).length;


const basicFormat = (value:any) => {
    return `${value.toLocaleString('pl-PL', {
        maximumFractionDigits: 0,
    })}`;
}
const currencyFormat = (value: any) => {
    let newValue = value;
    if (typeof value === 'string' && value.includes(',')) {
        newValue = Number(value.replace(/,/g, '.')) * 100;
    }

    return `${(newValue / 100).toLocaleString('pl-PL', {
        maximumFractionDigits: 0,
        style: 'currency',
        currency: 'PLN',
    })}`;
}

const lengthFormat = (value: any) => {
    return `${(value).toLocaleString('pl-PL', {
        maximumFractionDigits: 0,
    })}`;
}

export {
    currencyFormat,
    basicFormat,
    lengthFormat,
    groupDataBy,
    includesCaseInsesitive
}